import {
  List,
  ListItem,
  Collapse,
  Typography,
  ListItemIcon,
} from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { useGlobalExpandNavItemData } from "./GlobalExpandNavItemData";
import "./index.scss";

const GlobalExpandNavItem = ({ item }) => {
  const { open, handleToggle } = useGlobalExpandNavItemData();

  return (
    <>
      <ListItem
        button
        onClick={handleToggle}
        className="global-expand-nav-item"
      >
        <ListItemIcon className="global-expand-nav-item__icon">
          {item.icon && <item.icon />}
        </ListItemIcon>

        <Typography className="global-expand-nav-item__title">
          {item.title}
        </Typography>

        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItem>

      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {item.subItems.map((subItem, index) => (
            <ListItem
              button
              key={index}
              component="a"
              href={subItem.href}
              className="global-expand-nav-item__sub-item"
            >
              <ListItemIcon className="global-expand-nav-item__sub-icon">
                {subItem.icon && <subItem.icon />}
              </ListItemIcon>

              <Typography className="global-expand-nav-item__sub-title">
                {subItem.title}
              </Typography>
            </ListItem>
          ))}
        </List>
      </Collapse>
    </>
  );
};

export default GlobalExpandNavItem;
